// Simple CryptoHelper using crypto-js AES with a passphrase.
// Provides encrypt/decrypt for strings and JSON payloads.
import CryptoJS from 'crypto-js';

const SECRET = process.env.REACT_APP_CRYPTO_SECRET || process.env.REACT_APP_CRYPTR_KEY || 'grp-default-secret';

const CryptoHelper = {
  encryptString(plainText) {
    if (plainText == null) return null;
    try {
      return CryptoJS.AES.encrypt(String(plainText), SECRET).toString();
    } catch (e) {
      return null;
    }
  },
  decryptString(cipherText) {
    if (!cipherText) return null;
    try {
      const bytes = CryptoJS.AES.decrypt(cipherText, SECRET);
      const decoded = bytes.toString(CryptoJS.enc.Utf8);
      return decoded || null;
    } catch (e) {
      return null;
    }
  },
  encryptJSON(payload) {
    try {
      const json = typeof payload === 'string' ? payload : JSON.stringify(payload);
      return this.encryptString(json);
    } catch (e) {
      return null;
    }
  },
  decryptJSON(cipherOrJson) {
    if (cipherOrJson == null) return null;
    // Try plain JSON first.
    if (typeof cipherOrJson === 'string') {
      try {
        return JSON.parse(cipherOrJson);
      } catch (_) {
        const decrypted = this.decryptString(cipherOrJson);
        if (!decrypted) return null;
        try {
          return JSON.parse(decrypted);
        } catch (_) {
          return null;
        }
      }
    }
    // Already object
    return cipherOrJson;
  }
};

export default CryptoHelper;
